import { InputMenu } from '@/components/common/Input'
import { Icon } from '@/components/icons/Icon'
import { type CardRefType } from '@/defs/card'
import { type RecType } from '@/defs/rec'
import { useCardsRec } from '@/hooks/useCardsRec'
import { useReduxSelector } from '@/store/hooks'
import { selectors } from '@/store/selectors'
import { cn } from '@/utils/commonUtil'

import { CardButtonArt } from '../../CardButtonArt/CardButtonArt'
import styles from '../CardControls.module.scss'

type Props = {
  rec: RecType
}

export const CardControlsArt = ({ rec }: Props) => {
  const { card, cardPartner } = useCardsRec({ rec })
  const isEnabled = useReduxSelector(selectors.patreonTier) === 'rare'

  const cardArt = (card?.uniqueArtwork?.length || 0) > 1 && { cardId: rec.cardId, name: rec.name }
  const cardPartnerArt = (cardPartner?.uniqueArtwork?.length || 0) > 1 && rec.partnerRef

  const options = [cardArt, cardPartnerArt].filter((v): v is CardRefType => !!v)

  if (options.length === 0) return null

  if ((options.length === 1 || !isEnabled) && options[0]) {
    return (
      <li className={styles.item}>
        <CardButtonArt
          cardId={options[0].cardId}
          className={styles.button}
          classNameDisabled={cn({ disabled: true, styles })}
        >
          <Icon name='palette' />
        </CardButtonArt>
      </li>
    )
  }

  const menuOptions = options.map(({ cardId, name }) => ({
    label: (
      <CardButtonArt cardId={cardId} className={styles.option}>
        {name}
      </CardButtonArt>
    ),
  }))

  return (
    <li className={styles.item}>
      <InputMenu aria-label='Change Card Art' className={styles.button} options={menuOptions} title='Change Card Art'>
        <Icon name='palette' />
      </InputMenu>
    </li>
  )
}
